import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowDownLeft: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M17 7 7 17' }],
    ['path', { d: 'M17 17H7V7' }],
  ],
];

export default ArrowDownLeft;
